import { get, post, put, patch } from "../Config"

export function SearchCorporateGovernanceFile({ params = {}, lang }) {
  return get({ url: `/v1/admin/corporate-governance-file`, params, lang })
}
export function GetCorporateGovernanceFileById({ id, lang }) {
  return get({ url: `/v1/admin/corporate-governance-file/${id}`, lang })
}
export function CreateCorporateGovernanceFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/corporate-governance-file`, params, data, lang })
}
export function UpdateCorporateGovernanceFile({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/corporate-governance-file/${id}`, params, data, lang })
}
export function PatchCorporateGovernanceFile({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/corporate-governance-file/${id}`, params, data, lang })
}
export function DeleteCorporateGovernanceFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/corporate-governance-file/mutiDelete`, params, data, lang })
}
